import React from 'react';
import KaraokeOrderFormView1FrameView from './KaraokeOrderFormView1FrameView';
import KaraokeOrderFormView1FormView from './KaraokeOrderFormView1FormView';
import KaraokeOrderPriceInfo from './KaraokeOrderPriceInfo';
import { FieldValidationErrorsType } from '../../../common/form/FrekulForm';

type KaraokeOrderFormView1FieldName =
  'royalty_order'|'already_entrusted'|'onvocal'|'duet'|'intro_click'|'physical'|'coupon_code';

export default function KaraokeOrderFormView1({
  getValue,
  setValue,
  getErrors,
  priceInfo,
  planAmount,
  view,
  isFirstView,
  onNext,
  completedCount,
} : {
  getValue: (name: KaraokeOrderFormView1FieldName) => string,
  setValue: (name: KaraokeOrderFormView1FieldName, value: string) => void,
  getErrors: (name: KaraokeOrderFormView1FieldName) => FieldValidationErrorsType,
  priceInfo: KaraokeOrderPriceInfo,
  planAmount: number,
  view: string,
  isFirstView: boolean,
  onNext: () => void,
  completedCount: number,
}) {

  const topRef = React.useRef(null);
  React.useEffect(() => {
    if (view === 'view1' && !isFirstView) {
      (topRef.current as HTMLElement|null)?.scrollIntoView();
    }
  }, [view]);

  return (
    <>
      <KaraokeOrderFormView1FrameView
          priceInfo={priceInfo}
          completedCount={completedCount}
      >
        <span ref={topRef} />
        <KaraokeOrderFormView1FormView
          getValue={getValue}
          setValue={setValue}
          getErrors={getErrors}
          priceInfo={priceInfo}
          planAmount={planAmount}
          onNext={() => onNext()}
        />
      </KaraokeOrderFormView1FrameView>
    </>
  );
}
